import { render, staticRenderFns } from "./FormChangeMetaDataReportGDS.vue?vue&type=template&id=586b2163&scoped=true&lang=pug"
import script from "./FormChangeMetaDataReportGDS.vue?vue&type=script&lang=js"
export * from "./FormChangeMetaDataReportGDS.vue?vue&type=script&lang=js"
import style0 from "./FormChangeMetaDataReportGDS.vue?vue&type=style&index=0&id=586b2163&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586b2163",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('586b2163')) {
      api.createRecord('586b2163', component.options)
    } else {
      api.reload('586b2163', component.options)
    }
    module.hot.accept("./FormChangeMetaDataReportGDS.vue?vue&type=template&id=586b2163&scoped=true&lang=pug", function () {
      api.rerender('586b2163', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/FormChangeMetaDataReportGDS.vue"
export default component.exports